import React from 'react';
import SheinSyncProgressBar from '@/shein-platform/components/SheinSyncProgressBar';
import { useSheinSyncJobs } from '@/shein-platform/context/SheinSyncJobContext';

/**
 * 全局同步进度：仅展示未被页面槽位认领的任务（切到其他页时仍可见）。
 * 样式与页面内槽位共用 SheinSyncProgressBar。
 */
export default function SheinGlobalSyncProgress() {
  const { globalBars, cancelTrack, cancellingIds } = useSheinSyncJobs();

  if (!globalBars.length) return null;

  return (
    <div className="shein-global-sync" aria-live="polite">
      {globalBars.map((progress) => (
        <SheinSyncProgressBar
          key={progress.trackId}
          progress={progress}
          onCancel={
            progress.status === 'queued' || progress.status === 'running'
              ? () => cancelTrack(progress.trackId)
              : undefined
          }
          cancelling={cancellingIds.has(progress.trackId)}
        />
      ))}
    </div>
  );
}
